module.exports = __webpack_public_path__ + "static/media/who.cfd682fe.jpg";